class ViewSmartreviewReviewInvoice {

    //NOTE: Cannot declare variables at top of class like in Typescript. In plain ES6 JS Microsoft Edge will fail to parse the script (but not other browsers)

    constructor(target) {
        var thisObj = this;
        console.log('PageSmartreviewReviewInvoice script v1');

        //Assign elements
        this.target = target;

        //Assign the form button onclick disable code - have to re-do this since this page doesn't use the main layout
        console.log('Assigning form button click disable..');
        Apfco.disableFormButtonsOnSubmit(this.target);

        //Call various initialization methods
        this.initializeLinkHtmlElements();
        this.initializeLineItemTableRows();
        this.refreshDisplay();
        this.initializeAssignEvents();
        this.initializeFormChangeDetection();
        this.initializeDisableFormInput();

        console.log('Page script load complete.');
    }

    initializeLinkHtmlElements() {
        console.log('Linking elements..');
        this.Form = this.target.getElementsByTagName("Form")[0];
        this.FormFieldsChanged = document.getElementById("FormFieldsChanged");
        this.IsReadOnly = document.getElementById("IsReadOnly");
        this.IsReadOnlyValue = (this.IsReadOnly.value === 'True');
        this.SubPendingUpdatesMade = this.target.getElementsByClassName('SubPendingUpdatesMade')[0];
        this.SubBtnAddLineItem = this.target.getElementsByClassName('SubBtnAddLineItem')[0];
        this.SubBtnUpdate = this.target.getElementsByClassName('SubBtnUpdate')[0];
        this.SubBtnReturnToSubmission = this.target.getElementsByClassName('SubBtnReturnToSubmission')[0];
    }

    initializeLineItemTableRows() {
        console.log('Building list of line items table rows..');
        this.ReviewInvoiceLineItems = [];
        var elementsByClass = document.getElementsByClassName("ReviewInvoiceLineItem");
        for (var i = 0; i < elementsByClass.length; i++) {
            this.ReviewInvoiceLineItems.push(new ReviewInvoiceLineItem(elementsByClass.item(i), this));
        };
    }

    initializeAssignEvents() {
        console.log('Assigning events..');
        var thisObj = this;
        if (this.SubBtnAddLineItem) //May be null if viewing as read-only
            this.SubBtnAddLineItem.onclick = function () {
                thisObj.addLineItem();
                return false; //Since this is an anchor tag, prevent any redirecting
            };
    }

    initializeFormChangeDetection() {
        console.log('Initializing form change detection..');
        var thisObj = this;
        $(this.Form).find(":input").change(function () {
            thisObj.setFormFieldsChanged();
        });
        $(this.Form).find(".UnqualifiedReasonReviewer").find(":input").click(function () {
            thisObj.setFormFieldsChanged();
        });
        $(this.Form).find(".UnqualifiedReasonAutoUnqualify").find(":input").click(function () {
            thisObj.setFormFieldsChanged();
        });
        $(this.Form).find(".SubBtnAddLineItem").click(function () {
            thisObj.setFormFieldsChanged();
        });
        $(this.Form).find(".SubBtnRemove").click(function () {
            thisObj.setFormFieldsChanged();
        });
    }

    initializeDisableFormInput() {
        if (this.IsReadOnlyValue) {
            console.log('IsReadOnly set to false - disabling all inputs..');

            //Specifically only get the elements that are visisble controls (don't want to disable the anti-forgery token or other hidden fields)
            let elements = this.Form.querySelectorAll('input.form-control,input.btn,button.btn,select.form-control,textarea.form-control');
            for (var i = 0; i < elements.length; ++i) {
                if (elements[i]) {
                    (elements[i]).disabled = true;
                }
            }

            //Reset some specific elements as enabled as they should always be available
            this.SubBtnReturnToSubmission.disabled = false;
        }
        else
            console.log('IsReadOnly set to false - leaving all inputs enabled..');
    }

    setFormFieldsChanged() {
        if (!this.IsReadOnlyValue) {
            console.log('Form fields changed.');
            this.FormFieldsChanged.value = 'True';
            this.SubPendingUpdatesMade.style.display = '';
        }
        else {
            console.log('Change occured but no edit/review allowed, no changes flagged');
        }
    }

    refreshDisplay() {
        console.log('Calling refreshDisplay()..');
        this.refreshDisplayLineItems();
    }

    refreshDisplayLineItems() {
        for (let i = 0; i < this.ReviewInvoiceLineItems.length; i++) {
            this.ReviewInvoiceLineItems[i].refreshDisplay();
        };
    }

    addLineItem() {
        console.log('Calling addLineItem()..');

        //Kind of a wierd way to do this, but basically going to loop through the list backwards and enable the last disabled row found. 
        //This way the only time rows will get enabled in the middle is if the user is doing a bunch of add / removes, rather than immediately after the first

        //Get the index of the last enabled value, add one, and then refresh the display
        let lastEnabledIndex = -1;
        for (var i = this.ReviewInvoiceLineItems.length - 1; i >= 0; i--) {
            console.log('Checking index: ' + i);
            console.log(this.ReviewInvoiceLineItems[i].IsEnabled.value);
            if (this.ReviewInvoiceLineItems[i].IsEnabled.value === 'True') {
                lastEnabledIndex = i;
                console.log('Found lastEnabledIndex: ' + lastEnabledIndex);
                break;
            }
        };
        let newEnabledIndex = lastEnabledIndex + 1;
        console.log('Set newEnabledIndex: ' + newEnabledIndex);
        this.ReviewInvoiceLineItems[newEnabledIndex].IsEnabled.value = 'True';
        this.refreshDisplay();
    }
}

class ReviewInvoiceLineItem {

    //NOTE: Cannot declare variables at top of class like in Typescript. In plain ES6 JS Microsoft Edge will fail to parse the script (but not other browsers)

    constructor(target, parent) {
        var thisObj = this;
        console.log('\nReviewInvoiceLineItem script v3\n');

        //Assign elements
        this.target = target;
        this.parent = parent;
        this.IsEnabled = this.target.getElementsByClassName('SubIsEnabled')[0];
        this.ProductFullDescription = this.target.getElementsByClassName('SubProductFullDescription')[0];
        this.Quantity = this.target.getElementsByClassName('SubQuantity')[0];
        this.BtnRemove = this.target.getElementsByClassName('SubBtnRemove')[0];

        //Set all input events
        this.BtnRemove.onclick = function () {
            thisObj.remove();
            return false; //Since this is an anchor tag, prevent any redirecting
        };
    }

    refreshDisplay() {
        console.log('ReviewInvoiceLineItem - Calling refreshDisplay()..');
        this.target.style.display = (this.IsEnabled.value === 'True' ? '' : 'none');
    }

    remove() {
        console.log('ReviewInvoiceLineItem - Calling remove()..');
        this.IsEnabled.value = 'False';
        this.ProductFullDescription.value = '';
        this.Quantity.value = '';        
        this.parent.refreshDisplay();
    }
}

//Instantiate on page load if matching HTML is found
let ViewSmartreviewReviewInvoiceList = [];
$(function () {
    if (document.body.classList.contains('cSmartreview') && document.body.classList.contains('aReviewInvoice')) {
        let elementsByClass = document.getElementsByClassName("viewWrapper");
        for (let i = 0; i < elementsByClass.length; i++) {
            ViewSmartreviewReviewInvoiceList.push(new ViewSmartreviewReviewInvoice(elementsByClass.item(i)));
        };
    }
});